import { IsOptional, ValidateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { advancedFormGroup } from '@magieno/common';
import { type } from '@pristine-ts/data-mapping-common';
import { CalculationDate } from '../../../../../models/calculation.date';
import {
  IncomeTaxPersonalChildFederalInSalaryDividendOptions,
} from './income-tax-personal-child-federal-in-salary-dividend.options';
import {
  IncomeTaxPersonalChildQuebecInSalaryDividendOptions,
} from './income-tax-personal-child-quebec-in-salary-dividend.options';
import { IncomeTaxPersonalChildOptions } from '../../../income-tax/personal/personal/income-tax-personal-child.options';
import {
  IncomeTaxPersonalChildCampOptions,
} from '../../../income-tax/personal/common/income-tax-personal-child-camp.options';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
    IncomeTaxPersonalChildCommonOptions,
} from '../../../income-tax/personal/common/income-tax-personal-child-common.options';
import { v4 as uuid } from 'uuid';

@translationBaseKey('income-tax-child-in-salary-dividend-options')
export class IncomeTaxPersonalChildInSalaryDividendOptions implements Omit<IncomeTaxPersonalChildOptions,
  'federal' |
  'quebec'
> {
  @type(() => new IncomeTaxPersonalChildFederalInSalaryDividendOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildFederalInSalaryDividendOptions,
  })
  @ValidateNested()
  @IsOptional()

  // todo: we know currentPath's last part will be this class. Remove our part and get our parent from the path.
  @ValidateIf((object: any, root: any, currentPath: string): boolean => {

    /*
    The code below is a replacement for this since we don't know for sure if the instanceof will work.
    if(root instanceof IncomeTaxPersonalOptions) {
      return root.isCareExpensesCalculated;
    } else if(root instanceof SalaryDividendOptions) {
      return root.incomeTaxPersonalOptions.isCareExpensesCalculated;
    }
     */

      if (root.hasOwnProperty('isCareExpensesCalculated')) {
          return root['isCareExpensesCalculated'];
      } else if (root.hasOwnProperty('incomeTaxPersonalOptions') && root['incomeTaxPersonalOptions'].hasOwnProperty('isCareExpensesCalculated')) {
          return root['incomeTaxPersonalOptions']['isCareExpensesCalculated'];
    }

    return false;
  })
  federal?: IncomeTaxPersonalChildFederalInSalaryDividendOptions;

  @type(() => new IncomeTaxPersonalChildQuebecInSalaryDividendOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildQuebecInSalaryDividendOptions,
  })
  @ValidateNested()
  @IsOptional()
  quebec?: IncomeTaxPersonalChildQuebecInSalaryDividendOptions;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'id')
  id: string = uuid();

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'firstName')
  firstName: string;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'lastName')
  lastName: string;

    @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'camps')
  camps: IncomeTaxPersonalChildCampOptions[] = [];

    @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'birthdate')
  birthdate: CalculationDate;

    @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'isDisabled')
  isDisabled: boolean;

    @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'netIncome')
  netIncome: number;
}
